export default {
  'system.host': {
    ko: '호스트명/IP 주소',
    ja: 'ホスト名/IPアドレス',
    en: 'Host/IP address',
  },
  'system.username': {
    ko: '사용자',
    ja: 'ユーザー',
    en: 'User',
  },
  'system.database.type': {
    ko: 'DBMS 종류',
    ja: 'DBMS種類',
    en: 'DBMS Type',
  },
  'system.timeZone': {
    ko: '시간대',
    ja: 'タイムゾーン',
    en: 'timeZone',
  },
  'system.numberOfCpu': {
    ko: '서버 코어 개수',
    ja: 'CPU Core数',
    en: 'Number of CPU Core',
  },
  'system.systemNumber': {
    ko: 'System No.',
    ja: 'システム番号',
    en: 'System No.',
  },
  'sstmgrp.dialog.sstmgrp': {
    ko: '시스템 그룹',
    ja: 'システムグループ',
    en: 'System group',
  },
  'system.liveCache.active': {
    ko: '활성화 여부',
    ja: '有効化の有無',
    en: 'Active',
  },
  'system.jmx.add.title': {
    ko: 'Java Stack 등록을 위한 JMX 연결 정보',
    ja: 'Javaスタックの登録のためのJMX接続情報',
    en: 'JMX connection information for Java Stack registration',
  },
  'system.color': {
    ko: '색상',
    ja: 'カラー',
    en: 'Color',
  },
  'system.description': {
    ko: '설명',
    ja: '説明',
    en: 'Description',
  },
  'system.select': {
    ko: '시스템 선택',
    ja: 'システム選択',
    en: 'Select system',
  },
  'sstmgrp.ctxt.menu.sub': {
    ko: '하위 그룹 추가',
    ja: '下位グループの追加',
    en: 'Add sub-group',
  },
  'sstmgrp.dialog.desc': {
    ko: '그룹의 이름을 입력하세요.',
    ja: 'グループ名を入力してください。',
    en: 'Input the name of the group',
  },
  'sstmgrp.dialog.delete': {
    ko: '삭제하시겠습니까?',
    ja: '削除しますか？',
    en: 'Do you really delete?',
  },
  'system.instance': {
    ko: '인스턴스',
    ja: 'インスタンス',
    en: 'Instance',
  },
  'system.whetherCollected': {
    ko: '수집여부',
    ja: '収集有無',
    en: 'Whether collecting',
  },
  'system.database.name': {
    ko: 'DB 명칭',
    ja: 'DB名',
    en: 'DB name',
  },
  'system.clientNumber': {
    ko: 'Client No.',
    ja: 'クライアント番号',
    en: 'Client No.',
  },
  'system.liveCache.connectionName': {
    ko: 'LiveCache 연결 명칭',
    ja: 'LiveCache接続名',
    en: 'LiveCache Connection Name',
  },
  'system.alias': {
    ko: '별칭',
    ja: 'エイリアス',
    en: 'Alias',
  },
  'system.version': {
    ko: '버전',
    ja: 'バージョン',
    en: 'Version',
  },
  'sstmgrp.ctxt.menu.del': {
    ko: '그룹 삭제',
    ja: 'グループ削除',
    en: 'Delete group',
  },
  'system.page.size': {
    ko: '메모리 페이지 크기',
    ja: 'メモリページサイズ',
    en: 'Page Size of Memory',
  },
  'system.osType': {
    ko: '운영체제',
    ja: 'OS',
    en: 'Operating System',
  },
  'system.node': {
    ko: '노드',
    ja: 'ノード',
    en: 'Node',
  },
  'system.port': {
    ko: '포트',
    ja: 'ポート',
    en: 'Port',
  },
  'sstmgrp.icon.top.group': {
    ko: '하위 그룹을 상위 그룹으로 옮기려면 여기에 하위 그룹을 끌어다 놓으세요.',
    ja: '下位グループを上位グループに移動させるには、下位グループをこちらにドラッグして置いてください。',
    en: 'If you move a subgroup to top group, drag and drop the subgroup on here.',
  },
  'system.password': {
    ko: '비밀번호',
    ja: 'パスワード',
    en: 'Password',
  },
  'system.jco.add.title': {
    ko: 'ABAP Stack 등록을 위한 JCo 연결 정보',
    ja: 'ABAPスタックの登録のためのJCo接続情報',
    en: 'JCo connection information for ABAP Stack registration',
  },
  'sstmgrp.ctxt.menu.add': {
    ko: '최상위 그룹 추가',
    ja: '最上位グループの追加',
    en: 'Add first level group',
  },
  'system.id': {
    ko: '아이디',
    ja: 'ID',
    en: 'ID',
  },
  'system.shortAlias': {
    ko: '짧은 별칭',
    ja: 'ショートエイリアス',
    en: 'Short Alias',
  },
  'sstmgrp.icon.trash': {
    ko: '그룹이나 시스템을 제거하려면 여기에 끌어다 놓으세요.',
    ja: 'グループまたはシステムを削除するには、こちらにドラッグして置いてください。',
    en: 'If you remove a group or system, drag and drop on here.',
  },
  'sstmgrp.ctxt.menu.upd': {
    ko: '그룹 이름 변경',
    ja: 'グループ名の変更',
    en: 'Change the name of the group',
  },
  'system.system': {
    ko: '시스템',
    ja: 'システム',
    en: 'System',
  },
  // BEGIN::Added.by.KWShin.2025.12.23.
  'system.dspl.order.up': {
    ko: '표시 순서를 위로...',
    ja: 'Move up display order...',
    en: 'Move up display order...',
    cn: 'Move up display order...',
  },
  'system.dspl.order.dn': {
    ko: '표시 순서를 아래로...',
    ja: 'Move down display order...',
    en: 'Move down display order...',
    cn: 'Move down display order...',
  },
  'system.dspl.order.update.q': {
    ko: '표시 순서를 변경하시겠습니까?',
    ja: 'Do you realy update the display order?',
    en: 'Do you realy update the display order?',
    cn: 'Do you realy update the display order?',
  },
  // FINISH::Added.by.KWShin.2025.12.23.
};
